module.exports = __webpack_public_path__ + "static/media/passenger_bg.a39fc122.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/passenger_bg.png
// module id = 1149
// module chunks = 2